import { Fragment, useRef } from 'react';
import { motion } from 'framer-motion';
import { useSeen } from '@/lib/experience';

const SPRING = { type: 'spring', stiffness: 420, damping: 14, mass: 0.8 };

/**
 * Título que entra palavra por palavra "quicando" (mola com bounce).
 * `parts`: [{ text, className, br }] — permite destacar trechos.
 * Se `play` for definido, controla a animação; senão anima ao chegar na tela.
 */
export const RevealWords = ({ parts, as: Tag = 'h2', className = '', play, delay = 0, stagger = 0.07 }) => {
  const MotionTag = motion[Tag] || motion.h2;
  const ref = useRef(null);
  const seen = useSeen(ref, 0.88);
  let index = 0;
  const show = play !== undefined ? play : seen;

  return (
    <MotionTag ref={ref} className={className} initial="hidden" animate={show ? 'show' : 'hidden'}>
      {parts.map((part, p) => {
        const words = part.text.split(' ').filter(Boolean);
        return (
          <Fragment key={p}>
            {words.map((word, w) => {
              const i = index++;
              return (
                <Fragment key={`${p}-${w}`}>
                  <motion.span
                    className={`inline-block will-change-transform ${part.className || ''}`}
                    variants={{
                      hidden: { y: 40, scale: 0.6, rotate: i % 2 ? 8 : -8, opacity: 0 },
                      show: { y: 0, scale: 1, rotate: 0, opacity: 1, transition: { ...SPRING, delay: delay + i * stagger } },
                    }}
                  >
                    {word}
                  </motion.span>
                  {part.br && w === words.length - 1 ? (
                    <>
                      {' '}
                      <br />
                    </>
                  ) : (
                    ' '
                  )}
                </Fragment>
              );
            })}
          </Fragment>
        );
      })}
    </MotionTag>
  );
};

export default RevealWords;
